"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.ModalGeneric = void 0;
const antd_1 = require("antd");
const styled_components_1 = __importDefault(require("styled-components"));
exports.ModalGeneric = (0, styled_components_1.default)(antd_1.Modal) `
  * {
    border-radius: 15px;
  }
  .ant-modal-title {
    font-size: 25px;
    text-align: center;
    margin: 20px 0;
    background-color: ${props => props.backgroundColor};
    color: ${props => props.fontColor};
    span {
      color: #ffff;
      font-weight: 500;
    }
  }
  .terms-modal-body {
    border: 1px solid rgba(999, 999, 999, 0.3);
    border-radius: 30px;
    margin: 5px 30px;
    padding: 30px;
    line-height: 1.7em;
    font-size: 18px;
    text-align: center;
    background-color: ${props => props.backgroundColor};
    color: ${props => props.fontColor};
    p {
      color: #ffff;
      font-weight: 300;
    }
  }

  .ant-modal-content {
    max-width: 1000px;
    margin: 0 auto;
    background-color: ${props => props.backgroundColor};
    color: ${props => props.fontColor};
  }
  .ant-modal-header {
    background-color: ${props => props.backgroundColor};
    color: ${props => props.fontColor};
    border: none;
  }
  .ant-modal-body {
    padding: 10px 0 30px 0;
  }
  .ant-modal-footer {
    border: none;
    display: ${props => (props.showFooter ? 'flex' : 'none')};
    justify-content: flex-end;
    button {
      border-radius: 5px;
    }
    button:hover {
      background-color: #ffff;
      color: ${props => props.backgroundColor};
    }
  }
  @media screen and (max-width: 992px) {
    width: 100% !important;
  }
`;
